export default (path) => {
  const splitNewPath =  path.split('/')
  splitNewPath.pop()
  const newPath = splitNewPath.join('/')
  return newPath
}